<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M5.25 2C6.35457 2 7.25 2.89543 7.25 4V14.5H6.5L5.90039 13.7002C5.33383 12.9448 4.44427 12.5 3.5 12.5H1V2H5.25ZM15 12.5H12.5C11.5557 12.5 10.6662 12.9448 10.0996 13.7002L9.5 14.5H8.75V4C8.75 2.89543 9.64543 2 10.75 2H15V12.5Z"
    fill="currentColor"
  />
</svg>
